<script>
	import { tweened } from 'svelte/motion';
  import { cubicOut } from 'eases-jsnext';
  
  export let amt = 0;
</script>
<style>
	progress {
		display: block;
		width: 100%;
    height: 6px;
    padding: 0;
    margin: 0
  }
  progress[value] {
  -webkit-appearance: none;
   appearance: none;
  }
  progress[value]::-webkit-progress-bar {
    background-color: #eee;
    border-radius: 2px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.16) inset;
  }
  progress[value]::-webkit-progress-value {
    background: #58CFEB;
    transition: all .5s ease-out;
  }
  ::-moz-progress-bar{background: #58cfeb;}
</style>

<progress value={amt}></progress>